import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setDeepLinkHandler } from '../services/deepLink';

// Mounted inside the Router (useNativeSetup runs outside it) — receives parsed
// share-extension deep links and routes them to the import page, which
// auto-starts the matching import from location.state.deepLink.
export default function DeepLinkHandler() {
  const navigate = useNavigate();

  useEffect(() => setDeepLinkHandler((link) => {
    navigate('/import', { state: { deepLink: link } });
  }), [navigate]);

  return null;
}
